import React, { useEffect, useRef, useState } from "react";

interface OtpInputProps {
  length: number;
  updateOtp: (otp: string) => void;
}

const OtpInput: React.FC<OtpInputProps> = (props) => {
  const [otp, setOtp] = useState<string[]>(new Array(props.length).fill(""));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 0); // Delay by a single tick
  
    return () => clearTimeout(timeout); // Cleanup timeout
  }, []);

  const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNaN(Number(value))) return;

    const newOtp = [...otp];
    // Allow only one input
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    // Trigger submit
    const combinedOtp = newOtp.join("");
    if (combinedOtp.length === props.length) {
      props.updateOtp(combinedOtp);
    }

    // Move to next input if the current field is filled
    if (value && index < props.length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleClick = (index: number) => {
    inputRefs.current[index]?.setSelectionRange(1, 1);
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === "Backspace" &&
      !otp[index] &&
      index > 0 &&
      inputRefs.current[index - 1]
    ) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  return (
    <div
      className="otp-input-group"
      role="group"
      aria-label={`${props.length}-digit verification code`}
    >
      {otp.map((value, index) => {
        return (
          <input
            key={index}
            type="text"
            ref={(input) => (inputRefs.current[index] = input)}
            value={value}
            onChange={(e) => handleChange(index, e)}
            onClick={() => handleClick(index)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            className="otpInput"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={1}
            autoComplete={index === 0 ? "one-time-code" : "off"}
            aria-label={`Digit ${index + 1} of ${props.length}`}
          />
        );
      })}
    </div>
  );
};

export default OtpInput;
